export const devWishData = {
  id: '0',
  number: '0',
  name: 'Handlers ทีมพัฒนา - Kanosume \'Kurumina\' Umiki',
  avatar: 'lotus',
  twitter: 'Prachameow',
  message: 'สุขสันต์วันเกิดนะครับน้องเนอ 🎂🎉\nขอบคุณที่เป็นแรงบันดาลใจและสร้างรอยยิ้มให้กับ Handlers มาเสมอ ขอให้น้องเนอมีความสุขมากๆ ในทุกๆ วัน สุขภาพแข็งแรง และมีแต่เรื่องดีๆ เข้ามาในชีวิตนะคับ ✨\nหวังว่าวันพิเศษวันนี้จะเต็มไปด้วยความอบอุ่นจากทุกคนที่รักและซัพพอร์ตเนอเสมอนะะ~ 💖\nเช่นเคยทุกปี ขอให้ดื่มชาซู่ให้อร่อย! 😊',
  createdAt: '2026-03-14T16:38:38.299Z',
  fanart: 'https://nirvana-fa-host.nephele.in.th/nir-cola.png'
};
